<template>
  <div class="align-items-center searchpanel-item">
    <div class="searchpanel mr-3">
      <form
        @submit.prevent="updateQuery"
        class="searching searchpanel-item mb-3"
      >
        <div class="input-group flex-nowrap">
          <div class="searching-wrapper searchpanel-item">
            <input
              type="text"
              class="form-control"
              placeholder="Szukaj"
              aria-label="Szukaj"
              v-model="q"
            />
            <span class="searching-icon">
              <i class="fas fa-search"></i>
            </span>
            <span class="searching-clean" v-show="search" @click="cleanQuery">
              <i class="fas fa-times"></i>
            </span>
          </div>
          <div class="input-group-append">
            <button
              class="btn btn-sm btn-outline-secondary d-none"
              type="submit"
            >
              Szukaj
            </button>
          </div>
        </div>
      </form>
      <div class="filters d-flex align-items-center">
        <b-dropdown
          text="Firma"
          ref="comapny"
          class="dropdowns mb-3"
          @hide="updateCompany"
        >
          <b-dropdown-form class="b-dropdown-form--minpadding">
            <b-form-checkbox-group
              name="comapny"
              v-model="company"
              :options="items"
          value-field="id"
          text-field="name"
              class="checkbox-group-stacked"
              stacked
            ></b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>


        <b-dropdown
          text="Status"
          ref="status"
          class="ml-2 dropdowns mb-3"
          @hide="updateStatus"
        >
          <b-dropdown-form class="b-dropdown-form--minpadding">
            <b-form-checkbox-group
              name="status"
              v-model="status"
              :options="avaibleStatus"
              class="checkbox-group-stacked"
              stacked
            ></b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>
        <b-dropdown
          text="Kierownik"
          ref="owner"
          class="ml-2 dropdowns mb-3"
          @hide="updateOwner"
          v-if="isNotSubcontractor"
        >
          <b-dropdown-form class="b-dropdown-form--minpadding">
            <TableSpiner v-if="availableEmployees() === false" />
            <b-form-checkbox-group
              v-else
              name="status"
              v-model="owner"
              :options="availableEmployees('onlyEmployee')"
              class="checkbox-group-stacked text-left"
              stacked
            ></b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>
        <b-dropdown
          text="Rok"
          ref="year"
          class="ml-2 dropdowns mb-3"
          @hide="updateYear"
        >
          <b-dropdown-form class="b-dropdown-form--minpadding">
            <b-form-checkbox-group
              name="year"
              v-model="year"
              :options="yearList"
              class="checkbox-group-stacked text-left"
              stacked
            ></b-form-checkbox-group>
          </b-dropdown-form>
        </b-dropdown>

        <b-form-checkbox
          name="not_assign"
          v-model="assign"
          @change="updateAssign"
          class="checkbox-group-stacked text-left ml-2 mb-3"
          v-if="assignEnable"
        >
          Wyświetl tylko nie przydzielone budowy
        </b-form-checkbox>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TableSpiner from "@/components/TableSpiner";
import dayjs from "dayjs";

export default {
  name: "ConstructionsSearchPanel",
  components: { TableSpiner },
  props: {
    search: Object,
    assignEnable: Boolean
  },
  data() {
    return {
      company: [],
      status: [],
      owner: [],
      year: [],
      yearList: [],
      assign: false,
      q: "",
    };
  },
  mounted() {
    this.status = this.search.status;
    this.owner = this.search.owner;
    this.q = this.search.q;
    this.year = this.search.year;
    this.assign = this.search.assign;

    (this.currentYear = dayjs()), (this.minYear = parseInt("2019"));
    this.currentYear = parseInt(dayjs(this.currentYear).format("YYYY"));
    this.yearList.push({
      text: this.currentYear + 1,
      value: this.currentYear + 1,
    });
    for (var i = this.currentYear; i >= this.minYear; i--) {
      this.yearList.push({ text: this.currentYear, value: this.currentYear });
      this.currentYear = this.currentYear - 1;
    }
  },
  computed: {
    ...mapGetters("app", ["optionsStatus", "availableEmployees"]),
    ...mapGetters("user", ["isNotSubcontractor"]),
    ...mapGetters("company", ["items"]),
    avaibleStatus() {
      let avaibleStatus = [],
        isSubcontractor = !this.isNotSubcontractor;
      this.$_.each(this.optionsStatus, (item) => {
        if (item.value === "not_payment" && isSubcontractor) {
          return;
        }
        avaibleStatus.push(item);
      });
      return avaibleStatus;
    },
  },

  methods: {
    updateOwner() {
      if (this.$_.isEqual(this.owner, this.search.owner)) return;
      this.$emit("search", {
        type: "owner",
        value: this.owner,
      });
    },
    updateCompany() {
      if (this.$_.isEqual(this.company, this.search.company)) return;
      this.$emit("search", {
        type: "company",
        value: this.company,
      });
    },
    updateStatus() {
      if (this.$_.isEqual(this.status, this.search.status)) return;
      this.$emit("search", {
        type: "status",
        value: this.status,
      });
    },
    updateYear() {
      if (this.$_.isEqual(this.year, this.search.year)) return;
      this.$emit("search", {
        type: "year",
        value: this.year,
      });
    },
    updateAssign() {
      this.$emit("search", {
        type: "assign",
        value: !this.assign,
      });
    },
    updateQuery() {
      if (this.$_.isEqual(this.q, this.search.q)) return;
      this.$emit("search", { type: "q", value: this.q });
    },
    cleanQuery() {
      this.q = "";
      this.$emit("search", { type: "q", value: "" });
    },
  },
};
</script>
